<template>
  <div id="" class="pop-up-wrap-user">
    <div class="pop-up-user button-wrap3 xlg">
      <div class="pop-header-user">
        <span class="title02">주문자 선택</span>
        <button
          class="btn-pop-close"
          id="btnRegisterClose"
          @click="$.emit('close')"
        >
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body3 admin-mt24">
        <div class="left-body sm">
          <div>
            <table class="tb-lst-payment tb-auth-user lg admin-mt0">
              <thead>
                <tr>
                  <td>No.</td>
                  <td>사원명</td>
                  <td>사원코드</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(orderer, i) in ordererList"
                  :key="orderer"
                  :class="{ on: selectIdx == orderer.idx }"
                  @click="
                    selectIdx = selectIdx == orderer.idx ? 0 : orderer.idx
                  "
                >
                  <td>{{ lpad(i + 1, 2, "0") }}</td>
                  <td>{{ orderer.name }}</td>
                  <td>{{ orderer.code }}</td>
                </tr>
              </tbody>
            </table>
            <div class="btn-arr-area pos-static landscape4 full-btn height-lg">
              <button class="admin-btn-up">
                <span class="overlay"></span>
              </button>
              <button class="admin-btn-down">
                <span class="overlay"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="right-body sm">
          <div class="fieldset">
            <div class="ip-row col02 lg">
              <label for="">사원코드</label>
              <input
                type="text"
                class="ip-comm center"
                id=""
                :value="
                  selectOrder == null
                    ? ordererList.filter((item) => item.idx == selectIdx)
                        .length == 0
                      ? null
                      : ordererList.filter((item) => item.idx == selectIdx)[0]
                          .code
                    : ordererList.filter(
                        (item) => item.idx == selectOrder.ordererIdx
                      ).length == 0
                    ? null
                    : ordererList.filter(
                        (item) => item.idx == selectOrder.ordererIdx
                      )[0].code
                "
                readonly
              />
            </div>
            <div class="ip-row col02 lg">
              <label for="">주문자</label>
              <input
                type="text"
                class="ip-comm center"
                id=""
                :value="
                  selectOrder == null
                    ? ordererList.filter((item) => item.idx == selectIdx)
                        .length == 0
                      ? null
                      : ordererList.filter((item) => item.idx == selectIdx)[0]
                          .name
                    : ordererList.filter(
                        (item) => item.idx == selectOrder.ordererIdx
                      ).length == 0
                    ? null
                    : ordererList.filter(
                        (item) => item.idx == selectOrder.ordererIdx
                      )[0].name
                "
                readonly
              />
            </div>
          </div>

          <div class="change-arrow" v-if="selectOrder != null"></div>
          <div class="fieldset" v-if="selectOrder != null">
            <div class="ip-row col02 lg">
              <label for="">사원코드</label>
              <input
                type="text"
                class="ip-comm change center"
                id=""
                :value="
                  ordererList.filter((item) => item.idx == selectIdx).length ==
                  0
                    ? null
                    : ordererList.filter((item) => item.idx == selectIdx)[0]
                        .code
                "
                readonly
              />
            </div>
            <div class="ip-row col02 lg">
              <label for="">주문자</label>
              <input
                type="text"
                class="ip-comm change center"
                id=""
                :value="
                  ordererList.filter((item) => item.idx == selectIdx).length ==
                  0
                    ? null
                    : ordererList.filter((item) => item.idx == selectIdx)[0]
                        .name
                "
                readonly
              />
            </div>
          </div>
          <div class="service-btn-area">
            <button
              type="button"
              class="btn-pop btn-submit btn-full admin-mb0"
              id="btnRegister"
              :disabled="selectIdx == 0"
              @click="$.emit('setSelectOrderer', selectIdx)"
            >
              선택<span class="overlay"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dimed"></div>
  </div>
</template>

<script>
export default {
  name: "ordererSelect",
  props: {
    selectOrder: Object,
  },
  data() {
    return {
      ordererList: [
        { idx: 1, name: "점장", code: "0001" },
        { idx: 2, name: "직원", code: "0002" },
      ],
      selectIdx: 0,
    };
  },
  methods: {
    lpad(str, padLen, padStr) {
      if (padStr.length > padLen) {
        return str;
      }
      str += "";
      padStr += "";
      while (str.length < padLen) str = padStr + str;
      str = str.length >= padLen ? str.substring(0, padLen) : str;
      return str;
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


